import { useQuery } from "@tanstack/react-query"
import { conversationMessageKnowledgeBaseItemsQuery } from "../lib/conversationMessageKnowledgeBaseItemsQuery"

export function useConversationMessageKnowledgeBaseItemsQuery(
  ...args: Parameters<typeof conversationMessageKnowledgeBaseItemsQuery>
) {
  return useQuery(conversationMessageKnowledgeBaseItemsQuery(...args))
}
